import React, {useEffect, useContext } from "react"
import { SectionContext } from "../context/sectionContext"
import { ErrorContext } from "../context/errorContext"
import { errorToastr } from "../../services/error-handler"
import { ConditionContext } from "../context/conditionContext"
import { JourneyContext } from "../context/journeyContext"
import { getValueFromJourney } from "../services/helperFunctions"
import { lineCapital } from "../../shared/functions"
import Parser from 'html-react-parser';

export default function ComponentGenderRadioFormGroup(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)

  const titleGenderValidation = (value) => {
    if(sectionState.sectionData["AppointeeFullNameTitle"]){
      if(sectionState.sectionData["AppointeeFullNameTitle"] === "MR" && value === "F"){
        errorToastr("Gender selected is not valid for title selected")
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: "Gender selected is not valid for title selected"
          })
        })
      }else if((sectionState.sectionData["AppointeeFullNameTitle"] === "MS" || sectionState.sectionData["AppointeeFullNameTitle"] === "MRS") && value === "M"){
        errorToastr("Gender selected is not valid for title selected")
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: "Gender selected is not valid for title selected"
          })
        })
      }else{
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: ""
          })
        })
      }
    } else  if(sectionState.sectionData["nomineeTitle"]){
      if(sectionState.sectionData["nomineeTitle"] === "MR" && value === "F"){
        errorToastr("Gender selected is not valid for title selected")
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: "Gender selected is not valid for title selected"
          })
        })
      }else if((sectionState.sectionData["nomineeTitle"] === "MS" || sectionState.sectionData["nomineeTitle"] === "MRS") && value === "M"){
        errorToastr("Gender selected is not valid for title selected")
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: "Gender selected is not valid for title selected"
          })
        })
      }else{
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: ""
          })
        })
      }
    } else if(sectionState.sectionData["titleNominee"]){
      if(sectionState.sectionData["titleNominee"] === "MR" && value === "F"){
        errorToastr("Gender selected is not valid for title selected")
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: "Gender selected is not valid for title selected"
          })
        })
      }else if((sectionState.sectionData["titleNominee"] === "MS" || sectionState.sectionData["titleNominee"] === "MRS") && value === "M"){
        errorToastr("Gender selected is not valid for title selected")
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: "Gender selected is not valid for title selected"
          })
        })
      }else{
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: ""
          })
        })
      }
    }
  }

  useEffect(() => {
    if(!sectionState.sectionData?.[props.data.formControlKey]){
      props.data.radioComponent.map((element) => {
        if(element.checked){
          if (sectionState.sectionId === props.sectionId) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: element.value,
                },
              }
            })
          } else {
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: props.sectionId,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: element.value,
                },
              }
            })
          }
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: element.value,
            }
          })
        }
      })
    }else{
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
        }
      })
    }
  },[])

  const handleEnter = (event,value) =>{
    console.log(event.key);
    if(event.key == 'Enter'){
      handleChange(value,{})
    }

  }

  const handleChange = (value, { target }) => {
    if(!props.data.disabled){
      if (sectionState.sectionId === props.sectionId) {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: value,
            },
          }
        })
      } else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: value,
            },
          }
        })
      }
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: value,
        }
      })
      if(props.sectionId === "AppointeeDetailSection"  && props.data.formControlKey === "gender"){
        titleGenderValidation(value)
      }
      else if(props.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails"  && (props.data.formControlKey === "nomineeGender"|| props.data.formControlKey === "AppointeeGender")){
        titleGenderValidation(value)
      }
      else if(props.sectionId === "FlexiEdgeFillProposalAppointeeSection"  && props.data.formControlKey === "AppointeeGender"){
        titleGenderValidation(value)
      }
    }
    if(props.saveApplicationAndCallBi){
      props.saveApplicationAndCallBi(props.data.formControlKey, value)
    }
    // console.log(sectionState, "section state")
  }
  return (
    <>
    <style>
      {
        `
        .gd-gender {
          margin-top: 15px !important;
      }
        `
      }
    </style>
      <div className='form-group row' style={{marginBottom:props.sectionId == "AppointeeDetailSection"?"-3px":"0px"}} >
        <p className="name-input-label inp-label">{(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}</p>
        {props.data.radioComponent.map((element, index) => {
          return (
            <div
              className={`col-md-4 col-xs-${
                12 / props.data.radioComponent.length
              }`}
              key={index}
            >
              <div
                className={`${element.name}-design ${element.value}`}
              >
                <div
                  className={`provider white-clr a${index + 1} ${
                    (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey])
                      ? sectionState.sectionData[props.data.formControlKey] ===
                          element.value && "active"
                      : element.checked
                      ? "active"
                      : ""
                  }`}
                  aria-hidden="true"
                  tabIndex="0"
                  onKeyPress = {(event)=>handleEnter( event,element.value)}
                  onClick={handleChange.bind(null, element.value)}
                >
                  <input
                    type={element.type}
                    // checked={
                    //   sectionState.sectionData[props.data.formControlKey]
                    //     ? sectionState.sectionData[
                    //         props.data.formControlKey
                    //       ] === element.value
                    //     : element.checked
                    // }
                    name={element.name}
                    value={element.value}
                    hidden
                  />
                  <p className="inp-label" >{(getValueFromJourney(
                                                journeyState.lookup.label,
                                                element.label
                                              )) || element.label}
                    {element.tooltip && 
                        <span style={{ marginLeft:"10px" } } className="tooltip-col text-tool-tip-design existing-tool-tip">
                          <div className="tool">i</div>
                          <span className="tooltiptext4 tooltiptext5 tooltiptext4-align-list "  style={{ width:"22rem",height:"fit-content",top:"auto" ,pointerEvents:"none"}}>
                            {Parser(element.tooltip)}
                          </span>
                        </span>
                        }
                  </p>
                  <label className={element.class}></label>       
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}
